export const faqItems = [
  {
    id: "faq-1",
    question: "网红爆料的内容来源可靠吗？",
    answer: "我们的内容团队由资深娱乐记者和网红行业观察者组成，每条爆料均经过多方核实与交叉验证后发布。所有实锤视频与解说均标注原始出处，确保信息透明可追溯。对于尚在核实中的线索，我们会明确标注「待证实」标签。",
  },
  {
    id: "faq-2",
    question: "网站更新频率如何？能否第一时间看到最新网红内幕？",
    answer: "我们保持每日更新，周一至周日不间断。热点事件发生后2小时内即有深度解说上线，重大爆料事件实时跟进更新。建议收藏本站或关注我们的社交媒体账号，确保不错过任何重磅网红瓜视频。",
  },
  {
    id: "faq-3",
    question: "如何投稿或提供网红爆料线索？",
    answer: "我们欢迎广大网友提供真实可靠的网红爆料线索。请通过本站的「联系我们」板块提交信息，或发送邮件至指定邮箱。所有投稿信息严格保密，爆料人身份绝对不公开，优质线索一经采用将给予丰厚奖励。",
  },
  {
    id: "faq-4",
    question: "视频播放不流畅怎么办？",
    answer: "建议切换至流畅画质或尝试使用Chrome、Edge等主流浏览器观看。如遇高峰期访问拥挤，可稍等片刻刷新页面。移动端用户请确保网络连接稳定，Wi-Fi环境下可获得最佳观看体验。",
  },
];

export const commentItems = [
  {
    id: "cmt-1",
    author: "吃瓜不嫌事大",
    avatar: "https://readdy.ai/api/search-image?query=default%20user%20avatar%20minimal%20circle%20icon%20with%20warm%20orange%20gradient%20background%20anonymous%20user%20profile&width=80&height=80&seq=avatar-01&orientation=squarish",
    time: "2小时前",
    content: "终于有人把这事说清楚了！之前看了好几个版本都是云里雾里的，这个网红实锤解说把整个时间线理得明明白白的，原来背后还有这么多不为人知的内幕。",
    likes: 2836,
  },
  {
    id: "cmt-2",
    author: "真相只有一个",
    avatar: "https://readdy.ai/api/search-image?query=default%20user%20avatar%20minimal%20circle%20icon%20with%20warm%20red%20gradient%20background%20anonymous%20user%20profile&width=80&height=80&seq=avatar-02&orientation=squarish",
    time: "5小时前",
    content: "这个网红黑料视频我反复看了三遍，每遍都有新发现。不得不说这个爆料团队真的专业，证据链完整，时间点对得上，比那些只会捕风捉影的营销号强太多了。",
    likes: 1521,
  },
  {
    id: "cmt-3",
    author: "资深吃瓜群众",
    avatar: "https://readdy.ai/api/search-image?query=default%20user%20avatar%20minimal%20circle%20icon%20with%20amber%20gradient%20background%20anonymous%20user%20profile&width=80&height=80&seq=avatar-03&orientation=squarish",
    time: "8小时前",
    content: "每日必刷的宝藏网站！更新速度是真的快，早上刚爆出的网红瓜视频，中午这边就有完整解说了。已经推荐给身边所有爱吃瓜的朋友，现在大家都在这蹲最新网红内幕。",
    likes: 974,
  },
];

export const featureItems = [
  {
    id: "feat-1",
    icon: "ri-fire-line",
    title: "全网最快爆料",
    description: "热点网红事件发生30分钟内即启动追踪，专业团队7×24小时轮值监控全网动态，确保第一时间呈现最新网红内幕实锤内容。",
  },
  {
    id: "feat-2",
    icon: "ri-shield-check-line",
    title: "多方实锤验证",
    description: "每条爆料均经过三重核实机制：原始素材溯源、多方当事人交叉确认、时间线逻辑还原，杜绝虚假信息和恶意造谣。",
  },
  {
    id: "feat-3",
    icon: "ri-video-line",
    title: "高清解说视频",
    description: "1080P高清画质配专业解说，关键证据逐帧标注，复杂事件用时间轴图表辅助理解，让吃瓜变得清晰明了。",
  },
  {
    id: "feat-4",
    icon: "ri-group-line",
    title: "百万吃瓜社区",
    description: "活跃的吃瓜群众社区，每篇爆料评论数千条，网友自发补充线索、分享观点，构建最全面的网红瓜视频讨论生态。",
  },
];

export const updateItems = [
  {
    id: "upd-1",
    date: "2026-07-30",
    time: "14:32",
    title: "知名带货网红涉嫌虚假宣传，粉丝集体维权事件最新进展",
    tag: "最新",
  },
  {
    id: "upd-2",
    date: "2026-07-30",
    time: "11:15",
    title: "某千万粉颜值博主人设崩塌，前团队员工实名曝内幕",
    tag: "爆料",
  },
  {
    id: "upd-3",
    date: "2026-07-30",
    time: "09:08",
    title: "短视频平台头部达人合约纠纷升级，双方各执一词",
    tag: "追踪",
  },
  {
    id: "upd-4",
    date: "2026-07-29",
    time: "20:45",
    title: "网红圈又出大瓜：知名美食博主被曝幕后代拍真相",
    tag: "独家",
  },
  {
    id: "upd-5",
    date: "2026-07-29",
    time: "16:20",
    title: "直播圈内幕人士爆料：礼物打赏背后的灰色产业链",
    tag: "深度",
  },
  {
    id: "upd-6",
    date: "2026-07-29",
    time: "10:30",
    title: "多位网红集体翻车事件完整时间线梳理及实锤证据汇总",
    tag: "合集",
  },
  {
    id: "upd-7",
    date: "2026-07-28",
    time: "19:55",
    title: "某MCN机构内部聊天记录流出，揭开网红包装产业链黑幕",
    tag: "实锤",
  },
  {
    id: "upd-8",
    date: "2026-07-28",
    time: "13:10",
    title: "粉丝经济乱象调查：网红数据注水、刷量产业链深度揭秘",
    tag: "调查",
  },
];

export const indexTopics = [
  {
    id: "idx-1",
    title: "直播带货翻车合集",
    count: 47,
    description: "收录网红直播带货中出现的虚假宣传、质量问题、售后纠纷等翻车事件完整合集",
    icon: "ri-shopping-cart-line",
  },
  {
    id: "idx-2",
    title: "网红人设崩塌实录",
    count: 35,
    description: "精心打造的人设一夜崩塌，真实面目曝光瞬间全记录",
    icon: "ri-ghost-line",
  },
  {
    id: "idx-3",
    title: "MCN机构内幕揭秘",
    count: 28,
    description: "深度揭露MCN机构的运作模式、合同陷阱和不为人知的行业内幕",
    icon: "ri-building-line",
  },
  {
    id: "idx-4",
    title: "短视频造假实锤",
    count: 52,
    description: "摆拍、剧本、剪辑造假手法全揭露，还原短视频背后的真实情况",
    icon: "ri-movie-line",
  },
  {
    id: "idx-5",
    title: "网红圈情感大瓜",
    count: 63,
    description: "网红之间的恋爱、分手、出轨等情感纠纷事件完整吃瓜指南",
    icon: "ri-heart-line",
  },
  {
    id: "idx-6",
    title: "平台算法黑箱解密",
    count: 19,
    description: "深入解析各大短视频和直播平台的推荐算法机制与流量分配规则",
    icon: "ri-code-line",
  },
  {
    id: "idx-7",
    title: "年度十大网红事件",
    count: 15,
    description: "每年最具影响力的网红爆料事件完整回顾与深度分析",
    icon: "ri-award-line",
  },
];

export const mediaItems = [
  {
    id: "med-1",
    title: "千万网红人设崩塌全解析：从爆红到翻车的180天",
    thumbnail: "https://readdy.ai/api/search-image?query=dramatic%20dark%20studio%20scene%20with%20warm%20red%20and%20amber%20lighting%20breaking%20news%20style%20video%20thumbnail%20with%20abstract%20cracked%20mask%20symbolizing%20exposed%20truth%20cinematic%20atmosphere&width=640&height=360&seq=media-card-01&orientation=landscape",
    duration: "18:42",
    views: "128.6万",
    tag: "热门",
  },
  {
    id: "med-2",
    title: "直播带货套路大起底：你买到的便宜货到底值不值",
    thumbnail: "https://readdy.ai/api/search-image?query=dark%20dramatic%20ecommerce%20livestream%20scene%20with%20shopping%20cart%20and%20question%20marks%20warm%20amber%20spotlight%20investigative%20journalism%20style%20video%20thumbnail%20with%20suspenseful%20atmosphere&width=640&height=360&seq=media-card-02&orientation=landscape",
    duration: "22:15",
    views: "96.3万",
    tag: "深度",
  },
  {
    id: "med-3",
    title: "MCN签约内幕：网红与机构的爱恨情仇完整版",
    thumbnail: "https://readdy.ai/api/search-image?query=corporate%20drama%20scene%20with%20contract%20papers%20and%20broken%20chains%20symbolizing%20freedom%20dark%20warm%20lighting%20with%20red%20accents%20investigative%20documentary%20style%20video%20thumbnail&width=640&height=360&seq=media-card-03&orientation=landscape",
    duration: "25:08",
    views: "83.7万",
    tag: "独家",
  },
  {
    id: "med-4",
    title: "2026上半年网红圈十大名场面事件回顾盘点",
    thumbnail: "https://readdy.ai/api/search-image?query=countdown%20top%20ten%20style%20video%20thumbnail%20with%20dramatic%20red%20and%20gold%20lighting%20trophy%20silhouette%20year%20in%20review%20entertainment%20news%20style%20cinematic%20warm%20tones&width=640&height=360&seq=media-card-04&orientation=landscape",
    duration: "35:50",
    views: "156.2万",
    tag: "合集",
  },
];

export const topicItems = [
  { id: "tpc-1", name: "直播翻车", heat: 98, count: "2.3万讨论" },
  { id: "tpc-2", name: "网红塌房", heat: 95, count: "1.8万讨论" },
  { id: "tpc-3", name: "带货虚假宣传", heat: 91, count: "1.5万讨论" },
  { id: "tpc-4", name: "MCN黑幕", heat: 87, count: "1.2万讨论" },
  { id: "tpc-5", name: "短视频造假", heat: 84, count: "9800讨论" },
  { id: "tpc-6", name: "人设崩塌", heat: 79, count: "8600讨论" },
  { id: "tpc-7", name: "情感大瓜", heat: 76, count: "7200讨论" },
  { id: "tpc-8", name: "刷量数据", heat: 72, count: "6500讨论" },
  { id: "tpc-9", name: "合约纠纷", heat: 68, count: "5800讨论" },
  { id: "tpc-10", name: "年度盘点评选", heat: 63, count: "5100讨论" },
  { id: "tpc-11", name: "新人爆料投稿", heat: 58, count: "4300讨论" },
];

export const rankingItems = [
  {
    id: "rnk-1",
    rank: 1,
    title: "某千万粉带货主播涉嫌售假，品牌方发声明切割",
    heat: "热度爆表",
    change: "up",
  },
  {
    id: "rnk-2",
    rank: 2,
    title: "知名情侣网红分手内幕：第三者插足证据确凿",
    heat: "持续升温",
    change: "up",
  },
  {
    id: "rnk-3",
    rank: 3,
    title: "头部MCN被曝克扣网红分成，多名达人集体解约",
    heat: "新晋热搜",
    change: "new",
  },
  {
    id: "rnk-4",
    rank: 4,
    title: "短视频平台算法大调整，中小网红流量暴跌真相",
    heat: "稳定关注",
    change: "same",
  },
  {
    id: "rnk-5",
    rank: 5,
    title: "网红圈税务风波持续发酵，监管部门或将出手",
    heat: "快速上升",
    change: "up",
  },
];

export const cardItems = [
  {
    id: "crd-1",
    title: "从素人到千万网红再到翻车：一个网红的完整生命周期",
    image: "https://readdy.ai/api/search-image?query=dramatic%20rise%20and%20fall%20visual%20metaphor%20with%20broken%20crown%20on%20dark%20stage%20warm%20spotlight%20documentary%20style%20editorial%20photography%20with%20deep%20shadows%20and%20golden%20accents&width=800&height=500&seq=card-01&orientation=landscape",
    excerpt: "深度复盘一位网红从默默无闻到全网爆红再到人设崩塌的全过程，揭示流量时代网红经济的残酷真相与行业规律。",
    tag: "深度报道",
    date: "2026-07-29",
  },
  {
    id: "crd-2",
    title: "直播间的秘密：礼物打赏背后的资本游戏与心理操控",
    image: "https://readdy.ai/api/search-image?query=mysterious%20livestream%20room%20with%20floating%20gift%20icons%20and%20money%20symbols%20dark%20ambient%20lighting%20with%20red%20glow%20investigative%20journalism%20style%20editorial%20photography&width=800&height=500&seq=card-02&orientation=landscape",
    excerpt: "深入调查直播打赏生态，揭秘平台、公会、主播三方如何利用人性弱点设计消费陷阱，以及背后的资金流转真相。",
    tag: "调查报道",
    date: "2026-07-28",
  },
  {
    id: "crd-3",
    title: "网红数据造假产业链：从刷粉到刷单的完整商业闭环",
    image: "https://readdy.ai/api/search-image?query=abstract%20data%20manipulation%20concept%20with%20glowing%20numbers%20and%20robot%20hands%20on%20dark%20background%20warm%20red%20and%20amber%20accents%20cyber%20noir%20editorial%20photography&width=800&height=500&seq=card-03&orientation=landscape",
    excerpt: "曝光网红行业数据造假的全产业链条，从刷粉丝、刷评论到刷销量的灰色操作手法及背后技术揭秘。",
    tag: "独家揭秘",
    date: "2026-07-27",
  },
  {
    id: "crd-4",
    title: "网红孵化器的真相：那些被包装出来的完美人设如何炼成",
    image: "https://readdy.ai/api/search-image?query=artistic%20mannequin%20being%20painted%20and%20decorated%20in%20dark%20studio%20with%20warm%20spotlight%20symbolizing%20manufactured%20persona%20editorial%20conceptual%20photography&width=800&height=500&seq=card-04&orientation=landscape",
    excerpt: "走进MCN机构的网红孵化流水线，看一个普通人如何经过全方位的包装和培训，变成拥有百万粉丝的完美网红。",
    tag: "行业观察",
    date: "2026-07-26",
  },
  {
    id: "crd-5",
    title: "网红税务问题大起底：高收入背后的缴税迷局与合规风险",
    image: "https://readdy.ai/api/search-image?query=serious%20tax%20documents%20and%20calculator%20with%20dark%20dramatic%20lighting%20golden%20coins%20and%20warning%20symbols%20financial%20investigation%20editorial%20photography%20with%20warm%20amber%20tones&width=800&height=500&seq=card-05&orientation=landscape",
    excerpt: "随着网红经济规模突破万亿，网红群体的税务合规问题日益凸显。本文深度解析网红收入的税务处理现状与潜在法律风险。",
    tag: "财经分析",
    date: "2026-07-25",
  },
];

export const carouselItems = [
  {
    id: "crs-1",
    title: "2026网红圈地震级事件：年度最大爆料完整复盘",
    subtitle: "历时三个月调查，完整还原事件始末",
    image: "https://readdy.ai/api/search-image?query=earthquake%20crack%20through%20social%20media%20icons%20dramatic%20dark%20scene%20with%20golden%20light%20breaking%20through%20cracks%20cinematic%20epic%20atmosphere%20with%20warm%20red%20and%20amber%20tones%20blockbuster%20style&width=1200&height=600&seq=carousel-01&orientation=landscape",
    tag: "重磅专题",
    link: "#cards",
  },
  {
    id: "crs-2",
    title: "网红与MCN的爱恨情仇：百位达人签约血泪史",
    subtitle: "独家采访多位解约网红，揭露行业潜规则",
    image: "https://readdy.ai/api/search-image?query=torn%20contract%20papers%20floating%20in%20dramatic%20dark%20space%20with%20chains%20breaking%20and%20warm%20golden%20light%20rays%20cinematic%20emotional%20atmosphere%20freedom%20theme&width=1200&height=600&seq=carousel-02&orientation=landscape",
    tag: "深度调查",
    link: "#media",
  },
  {
    id: "crs-3",
    title: "假货泛滥的直播带货：消费者该如何保护自己",
    subtitle: "实测50款网红带货产品，揭露惊人真相",
    image: "https://readdy.ai/api/search-image?query=counterfeit%20products%20under%20magnifying%20glass%20in%20dark%20dramatic%20setting%20with%20red%20warning%20glow%20investigative%20consumer%20protection%20theme%20cinematic%20editorial%20photography&width=1200&height=600&seq=carousel-03&orientation=landscape",
    tag: "消费警示",
    link: "#ranking",
  },
  {
    id: "crs-4",
    title: "从顶流到查无此人：那些消失的网红都去了哪里",
    subtitle: "追踪50位过气网红的现状与转型之路",
    image: "https://readdy.ai/api/search-image?query=disappearing%20silhouettes%20fading%20into%20darkness%20with%20one%20remaining%20figure%20in%20warm%20golden%20spotlight%20nostalgic%20contemplative%20cinematic%20atmosphere%20editorial%20photography&width=1200&height=600&seq=carousel-04&orientation=landscape",
    tag: "年度策划",
    link: "#cards",
  },
];